export const borderRadius = {
  button: 'none',
  badge: '4px',
};
